import React, {useContext, useState, useEffect} from 'react';
import {createPortal} from 'react-dom';
import Detail from './FolloweeDetail';
import {observer, inject} from 'mobx-react';
import RootStore from '../../store/RootStore';
import usePortalDom from '../hooks/usePortalDom';
import {pushHistory, popHistory} from '../../utils/history';
import {IPerson} from '../../global.d';
import intl from 'react-intl-universal';
import wxUtil from '../../utils/wx';
import AllForPendantV2, {IOneButton} from '../ComponentPendantV2/AllForPendant';
import {IPendantButton} from '../../component.d';
import Button from '../Common/Button';
import './AllForPersonDetail.scss';

interface IAllForPersonDetail {
  rootStore?:RootStore;
  hideBack?:boolean;
}

const Index = (props:IAllForPersonDetail)=>{
  const {hideBack} = props;
  const {relationStore, wxuserStore, uiStore, galleryStore} = props.rootStore!;
  const {person, personAlbum, friends} = relationStore;
  const [visible, setVisible] = useState(false);

  const onHidePage = ()=>{
    popHistory();
  };

  useEffect(()=>{
    if(person && person.id) {
      setVisible(true);
      pushHistory(`followeedetail_${person.id}`, ()=>{
        // 清空数据
        relationStore.clearCurrentPerson();
        setVisible(false);
      });
    }else {
      setVisible(false);
    }
  }, [person]);

  const wrapper = usePortalDom({
    targetClassName:"all-for-followee-detail",
    parentElement:window.document.getElementById('root-page')! as HTMLDivElement
  });

  const unfollow = (person:IPerson) => {
    if(wxuserStore.user.is_mock) {
      return wxuserStore.auth();
    }
    uiStore.showToast({
      content:intl.get('Processing')
    });
    wxuserStore.unfollow(person.id).then(()=>{
      uiStore.hideToast();
      uiStore.showToast({
        content:intl.get('Unfollow') + intl.get('Success')
      })
    })
  };

  const follow = (person:IPerson) => {
    let params = {
      image: person.faceurl,
      name: person.name,
      personid: person.id
    };
    if(wxuserStore.user.is_mock) {
      return wxuserStore.auth();
    }
    uiStore.showToast({
      content:intl.get('Processing')
    });
    wxuserStore.follow(params).then(() => {
      relationStore.follower();
      uiStore.hideToast();
      uiStore.showToast({
        content:intl.get('Follow') + intl.get('Success')
      })
    });
  };

  const onShowShare = (personid:string|number)=>{
    let share = wxUtil.configPersonShare(personid);
    wxUtil.showShareTip(share.url, uiStore);
  };

  return visible && wrapper ? createPortal(
    <div className="all-for-person-detail">
      <Detail person={person} personAlbum={personAlbum} followeeList={friends}
        onBack={onHidePage} onFollow={follow} onUnfollow={unfollow}
        onShowShare={onShowShare} jigsaw={galleryStore.jigsaw} setJigsaw={galleryStore.setJigsaw}
        rootStore={props.rootStore}
      />
      <AllForPendantV2 cid="person-detail" type="pendant" api="v2" useLocalDom={true} container={{
        top:0,
        bottom:0,
        left:0,
        right:10
      }} buttons={[
        window.isweixin ? {
          child: <span>{intl.get('Download-Pendent')}</span>,
          event:()=>{
            galleryStore.setJigsaw({
              type:"download",
              bottomShow: true,
              jigsawList:[]
            });
          },
          type: 'event',
          show: true
        } : undefined,
        {
          child: <span>{intl.get('ChooseShare')}</span>,
          event:()=>{
            galleryStore.setJigsaw({
              type:"share",
              bottomShow: true,
              jigsawList:[]
            });
          },
          type: 'event',
          show: true
        },
        !hideBack ? {
          className:"pendant-return-wrapper",
          child: <Button className="pendant-return">{intl.get('Back Home')}</Button>,
          event:()=>{
            onHidePage();
          },
          type: 'event',
          show: true
        } : undefined
      ].filter(Boolean) as IOneButton[]} />
    </div>
  , wrapper) : null;
};

export default inject('rootStore')(observer(Index));
